<template>
  <vx-card class="p-0" :title="$t('fees')">
    <vs-popup
      class="holamundo"
      :title="$t('In_which_classes_will_you_use_this_type_of_fee')"
      :active.sync="popupActive"
    >
      <!-- <p>
        {{ $t('class') }}
        <b style="color: #ff6141;">*</b>
      </p>
      <v-select
        multiple
        :options="classes"
        @search="getClasse"
        :clearable="true"
        :closeOnSelect="false"
        label="libelle"
        v-model="input_classes"
        class="w-full"
      /> -->

      <vs-list>
        <vs-list-header title="Les classes concernées par ce type de frais" color="primary"></vs-list-header>
        <vs-list-item :title="$t('Select_all')">
          <vs-checkbox slot="avatar" color="success" v-model="list1CheckBox"></vs-checkbox>

        </vs-list-item>

        <vs-list-item v-for="(classe, index) in classes" :key="index" @click="classe.checkBox = classe.checkBox ? false : true" :title="classe.libelle">
          <vs-checkbox slot="avatar" color="success" v-model="classe.checkBox"></vs-checkbox>

          <vs-chip color="success">
            <b>
              {{ index + 1 }}

            </b>
          </vs-chip>
        </vs-list-item>
      </vs-list>

      <vs-button
        v-if="!input_classes.length"
        class="mt-5"
        icon-pack="feather"
        icon="icon-check"
        disabled
      >
        Valider
      </vs-button>
      <vs-button
        v-if="input_classes.length"
        class="mt-5"
        icon-pack="feather"
        icon="icon-check"
        @click="validerFonction()"
      >
        Valider
      </vs-button>
    </vs-popup>

    <configuration-globale
      :tempon-classes="temponClasses"
      :statut-eleves="statutEleves"
      :get-statut-eleve="getStatutEleve"
      :frais_input="frais_input"
      :frais_input1="frais_input"
    />

    <form-wizard
      v-if="formwizard1"
      color="rgba(var(--vs-primary), 1)"
      errorColor="rgba(var(--vs-danger), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
    >
      <tab-content
        :key="indexItem"
        v-for="(item, indexItem) in input_classes"
        :title="item.libelle"
        class="mb-5"
        :before-change="step_validate(item.id)"
      >
        <!-- tab 1 content -->
        <form :data-vv-scope="'step-' + item.id">
          <div class="vx-row" @mouseenter="id_general = item.id">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <p class="mb-4">
                {{ $t('Student_status') }}
                <b style="color: #ff6141;">*</b>
              </p>
              <v-select
                multiple
                :options="statutEleves"
                @search="getStatutEleve"
                :clearable="true"
                :closeOnSelect="false"
                label="libelle"
                v-model="frais_input[item.id].statutEleves_add"
                class="w-full"
                :name="'classestudentstatus' + item.id"
                v-validate="'required'"
              />
              <span class="text-danger">
                {{
                  errors.first(errorsFirst('classestudentstatus', item.id, item.id))
                }}
              </span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5">
              <p class="mb-4">
                {{ $t('Amount') }}
                <b style="color: #ff6141;">*</b>
              </p>
              <vs-input-number
                class="ml-0 w-full"
                v-model="frais_input[item.id].montant"
                :name="'classemontant' + item.id"
                v-validate="'required'"
              />
              <span class="text-danger">
                {{
                  errors.first(errorsFirst('classemontant', item.id, item.id))
                }}
              </span>
            </div>

            <div class="vx-col md:w-1/4 w-full mt-5">
              <p class="mb-4">
                {{ $t('number_of_slice') }}
                <b style="color: #ff6141;">*</b>
              </p>
              <vs-input-number
                class="ml-0 w-full"
                v-model="frais_input[item.id].nombreDeTranche"
                :name="'classenombreDeTranche' + item.id"
                v-validate="'required'"
              />
              <span class="text-danger">
                {{
                  errors.first(
                    errorsFirst('classenombreDeTranche', item.id, item.id),
                  )
                }}
              </span>
            </div>

            <div
              :key="trancheindexItem"
              v-for="(tranche, trancheindexItem) in frais_input[item.id].tranches"
              class="vx-col md:w-1/2 w-full mt-5"
            >
              <vs-list>
                <vs-list-header
                  icon-pack="feather"
                  icon="icon-crop"
                  :title="'Tranche ' + (trancheindexItem + 1)"
                ></vs-list-header>
                <vs-list-item
                  icon-pack="feather"
                  icon="icon-dollar-sign"
                  :title="$t('Amount')"
                >
                  <vs-input-number
                    class="ml-0 w-full"
                    v-model="tranche.montant"
                    :name="
                      'classemontant' + (trancheindexItem + 1) + '-' + item.id
                    "
                    v-validate="'required'"
                  />
                  <span class="text-danger">
                    {{
                      errors.first(
                        errorsFirst(
                          'classemontant',
                          item.id,
                          trancheindexItem + 1 + '-' + item.id,
                        ),
                      )
                    }}
                  </span>
                </vs-list-item>
                <vs-list-item
                  icon-pack="feather"
                  icon="icon-calendar"
                  :title="$t('Start_date')"
                >
                  <datepicker
                    v-model="tranche.dateDebut"
                    :name="
                      'classedateDebut' + (trancheindexItem + 1) + '-' + item.id
                    "
                    v-validate="'required'"
                  ></datepicker>
                  <span class="text-danger">
                    {{
                      errors.first(
                        errorsFirst(
                          'classedateDebut',
                          item.id,
                          trancheindexItem + 1 + '-' + item.id,
                        ),
                      )
                    }}
                  </span>
                </vs-list-item>
                <vs-list-item
                  icon-pack="feather"
                  icon="icon-calendar"
                  :title="$t('End_date')"
                >
                  <datepicker
                    v-model="tranche.dateFin"
                    :name="
                      'classedateFin' + (trancheindexItem + 1) + '-' + item.id
                    "
                    v-validate="'required'"
                  ></datepicker>
                  <span class="text-danger">
                    {{
                      errors.first(
                        errorsFirst(
                          'classedateFin',
                          item.id,
                          trancheindexItem + 1 + '-' + item.id,
                        ),
                      )
                    }}
                  </span>
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 2 content  montant: '',
  dateDebut: '',
  dateFin: '' -->
      <!-- step_validate(item.id) <tab-content v-if="formwizard" :title="$t('school_year')" class="mb-5" :before-change="school_year_validate">
        <form data-vv-scope="school_year">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">

            <p class="mt-4" > {{ $t('Start_year') }} <b style="color: #ff6141">*</b> </p>
            <v-select :options="annees" @search="getAnnee" :clearable="true" label="valeur" v-model="annee_scolaire_input.anneeDebut" class="w-full" name="anneeDebut" v-validate="'required'"/>
            <span class="text-danger">{{ errors.first('school_year.anneeDebut') }}</span>

            <p class="mt-4" > {{ $t('End_year') }} <b style="color: #ff6141">*</b> </p>
            <v-select :options="annees1" @search="getAnnee1" :clearable="true" label="valeur" v-model="annee_scolaire_input.anneeFin" class="w-full" name="anneeFin" v-validate="'required'" />
            <span class="text-danger">{{ errors.first('school_year.anneeFin') }}</span>

          </div>
          <div class="vx-col md:w-1/2 w-full">
            <p class="mt-4" > {{ $t('Start_date') }} <b style="color: #ff6141">*</b> </p>
            <datepicker v-model="annee_scolaire_input.dateDebut" name="dateDebut" v-validate="'required'"></datepicker>
            <span class="text-danger">{{ errors.first('school_year.dateDebut') }}</span>
          </div>
        </div>
        </form>
      </tab-content> -->
    </form-wizard>
  </vx-card>
</template>

<script>
let base_self = ''
import Datepicker from 'vuejs-datepicker'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import ConfigurationGlobale from './ConfigurationGlobale.vue'

// For custom error message
import { Validator } from 'vee-validate'

const annee_scolaire_input_tempon = {
  encours: true,
  cloture: false,
  libelle: '',
  anneePrecedente: '',
  // à remplir
  dateDebut: new Date(),
  anneeFin: '',
  anneeDebut: ''
}

const frais_input_tempon = {
  id: null,
  anneeScolaire: '',
  typeFrais: '',
  classe: '',
  montant: '',
  nombreDeTranche: '',
  tranches: [],
  statutEleves_add: []
}

const tranches_input_tempon = {
  montant: '',
  dateDebut: '',
  dateFin: ''
}

export default {
  watch: {
    frais_input: {
      handler () {
        base_self.frais_input_watch(false)
      },
      deep: true
    },
    list1CheckBox (value) {
      const length = base_self.classes.length
      for (let i = 0; i < length; i++) {
        base_self.classes[i].checkBox = value
      }
    }
  },
  data () {
    return {
      list1CheckBox: false,
      popupActive12: false,
      old_fees: [],
      is_new: true,
      formwizard1: false,
      formwizard: false,
      desired: true,
      classe_input: {},
      frais_input: {},
      frais_input1: {},
      classes: [],
      statutEleves: [],
      input_classes: [],
      temponClasses: [],
      popupActive: false,
      id_general: '',
      typeFraiss: [],
      annee_scolaire_encours: null,
      annee_scolaire_input: JSON.parse(
        JSON.stringify(annee_scolaire_input_tempon),
      ),
      annees: [],
      annees1: []
    }
  },
  methods: {
    initClasse () {
      const classeObject = {}

      let length = base_self.classes.length
      for (let i = 0; i < length; i++) {
        base_self.classes[i].checkBox = false
        classeObject[base_self.classes[i].id] = i
      }

      length = base_self.input_classes.length
      for (let i = 0; i < length; i++) {
        base_self.classes[classeObject[base_self.input_classes[i].id]].checkBox = true
      }
    },
    newFeesOrNot () {
      if (!base_self.$store.state.anneeScolaire) {
        window.getESM.error(base_self.$t('There_is_no_open_school_year'))
        base_self.$router.push('/accounting_management/type_of_fees').catch(() => {})
      } else {
        frais_input_tempon.anneeScolaire = base_self.$store.state.anneeScolaire.id
        const param = {
          is_get: true,
          // is_count: true,
          filter: {
            is_active: true,
            typeFrais__id: frais_input_tempon.typeFrais,
            anneeScolaire__id: base_self.$store.state.anneeScolaire.id
          }
        }

        base_self.$http
          .post(`${base_self.$store.state.route_for_esm}Frais`, param)
          .then((response) => {
            base_self.is_new = !(response.data.taille > 0)
            base_self.old_fees = response.data.data
            base_self.getClasseSimple()
            base_self.getStatutEleveSimple()
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
          })
      }
    },
    frais_input_watch (is_ok) {
      const length = base_self.input_classes.length
      for (let i = 0; i < length; i++) {
        const item = base_self.input_classes[i]

        if (
          is_ok ||
          base_self.frais_input1[item.id].nombreDeTranche !==
            base_self.frais_input[item.id].nombreDeTranche
        ) {
          const nombreDeTranche = Number(base_self.frais_input[item.id].nombreDeTranche)
          const tranches = []

          let uio = 0
          for (; uio < base_self.frais_input[item.id].tranches.length && uio < nombreDeTranche; uio++) {
            tranches.push(JSON.parse(JSON.stringify(base_self.frais_input[item.id].tranches[uio])))
          }

          for (; uio < nombreDeTranche; uio++) {
            tranches.push(JSON.parse(JSON.stringify(tranches_input_tempon)))
          }

          base_self.frais_input[item.id].tranches = tranches
        }
      }

      base_self.frais_input1 = JSON.parse(JSON.stringify(base_self.frais_input))
      //base_self.frais_input = JSON.parse(JSON.stringify(base_self.frais_input))
    },
    validerFonction () {
      const input_classes = []
      const length = base_self.classes.length
      for (let i = 0; i < length; i++) {
        if (base_self.classes[i].checkBox) {
          base_self.classes[i].checkBox = false
          input_classes.push(base_self.classes[i])
        }
      }

      base_self.input_classes = input_classes
      base_self.temponClasses = input_classes

      base_self.popupActive = false
      // base_self.formwizard1 = true
      base_self.initialiseElement()
    },
    getClasseSpeciale () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          niveau__is_active: true
        },
        orderby: ['ordre'],
        juste: {
          id: '',
          libelle: ''
        }
      }

      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasseSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          niveau__is_active: true
        },
        orderby: ['ordre']
      }
      if (!base_self.is_new) {
        data.filter['fraiss__state'] = true
        data.filter['fraiss__is_active'] = true
        data.filter['fraiss__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        data.filter['fraiss__typeFrais__id'] = frais_input_tempon.typeFrais
      }

      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          console.log('response: ', response)

          // base_self.classes = JSON.parse(JSON.stringify(response.data.data))
          base_self.input_classes = JSON.parse(JSON.stringify(response.data.data))
          base_self.popupActive = true

          base_self.initClasse()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getStatutEleveSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}StatutEleve`, data)
        .then((response) => {
          base_self.statutEleves = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          niveau__is_active: true,
          libelle__icontains: search
        },
        orderby: ['ordre']
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getStatutEleve (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          libelle__icontains: search
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}StatutEleve`, data)
        .then((response) => {
          base_self.statutEleves = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    errorsFirst (libelle, id, index) {
      return `step-${id}.${libelle}${index}`
    },
    getAnnee (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { valeur__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Annee`, data)
        .then((response) => {
          base_self.annees = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getAnnee1 (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { valeur__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Annee`, data)
        .then((response) => {
          base_self.annees1 = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    step_validate (id) {
      const libelle = `step-${id}`
      const validate = () => {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll(libelle).then((result) => {
            if (result) {
              if (base_self.input_classes[base_self.input_classes.length - 1].id === id) {
                base_self.submit()
              }
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
        })
      }

      return validate
    },
    school_year_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('school_year').then((result) => {
          if (result) {
            base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    finaliserOuvertureAnne () {
      const data = {
        id: base_self.annee_scolaire_encours.id,
        encours: false
      }

      base_self.$http
        .put(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          window.getESM.success(
            base_self.$t('The_school_year_is_added_successfully'),
            response,
          )
          base_self.$router
            .push('/year_opening_management/school_years/')
            .catch(() => {})
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    afterSubmit (data) {
      const frais_input = JSON.parse(JSON.stringify(base_self.frais_input))

      const length = base_self.typeFraiss.length
      const fraiss = []
      for (let i = 0; i < length; i++) {
        const item = base_self.typeFraiss[i]
        frais_input[item.id].anneeScolaire = data.id
        frais_input[item.id].classe = frais_input[item.id].classe.id

        fraiss.push(frais_input[item.id])
      }

      // many data
      const input = {
        many: true,
        data: fraiss
      }

      base_self.$vs.loading()
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Frais`, input)
        .then(() => {
          // console.log('response: ', response)
          // window.getESM.success(base_self.$t('The_school_year_is_added_successfully'), response)
          base_self.finaliserOuvertureAnne()
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    submit () {
      const frais_input = JSON.parse(JSON.stringify(base_self.frais_input))
      const fraiss = []
      console.log(' frais_input ', frais_input)
      const length = base_self.input_classes.length
      for (let i = 0; i < length; i++) {
        const item = base_self.input_classes[i]
        frais_input[item.id].is_active = true
        frais_input[item.id].anneeScolaire = frais_input[item.id].anneeScolaire.id ? frais_input[item.id].anneeScolaire.id : frais_input[item.id].anneeScolaire
        frais_input[item.id].classe = frais_input[item.id].classe.id ? frais_input[item.id].classe.id : frais_input[item.id].classe
        frais_input[item.id].typeFrais = frais_input[item.id].typeFrais.id ? frais_input[item.id].typeFrais.id : frais_input[item.id].typeFrais

        const length_2 = frais_input[item.id].statutEleves_add.length
        const statutEleves_add = []
        for (let j = 0; j < length_2; j++) {
          statutEleves_add.push(frais_input[item.id].statutEleves_add[j].id)
        }

        frais_input[item.id].statutEleves_add = statutEleves_add

        // ************************ statutEleves_delete ************************
        if (frais_input[item.id].statutEleves_add_old && frais_input[item.id].statutEleves_add_old.length) {
          const statutEleves_delete = []
          for (let io = 0; io < frais_input[item.id].statutEleves_add_old.length; io++) {
            let ok = false
            for (let uio = 0; uio < frais_input[item.id].statutEleves_add.length; uio++) {
              if (frais_input[item.id].statutEleves_add[uio] === frais_input[item.id].statutEleves_add_old[io].id) {
                ok = true
                break
              }
            }

            if (!ok) {
              statutEleves_delete.push(frais_input[item.id].statutEleves_add_old[io].id)
            }
          }

          frais_input[item.id].statutEleves_delete = statutEleves_delete
        }
        // ************************ statutEleves_delete ************************

        // ************************ tranches_delete ************************
        if (frais_input[item.id].tranches_old && frais_input[item.id].tranches_old.length) {
          const tranches_delete = []
          for (let io = 0; io < frais_input[item.id].tranches_old.length; io++) {
            let ok = false
            for (let uio = 0; uio < frais_input[item.id].tranches.length; uio++) {
              if (frais_input[item.id].tranches[uio].id && frais_input[item.id].tranches[uio].id === frais_input[item.id].tranches_old[io].id) {
                ok = true
                break
              }
            }

            if (!ok) {
              tranches_delete.push(frais_input[item.id].tranches_old[io].id)
            }
          }

          frais_input[item.id].tranches_delete = tranches_delete
        }
        // ************************ tranches_delete ************************

        // ************************ tranches_ordre ************************
        for (let uio = 0; uio < frais_input[item.id].tranches.length; uio++) {
          frais_input[item.id].tranches[uio].ordre = uio + 1
        }
        // ************************ tranches_ordre ************************
        

        fraiss.push(frais_input[item.id])
      }

      const fraiss_delete = []
      for (let i = 0; i < base_self.old_fees.length; i++) {
        let ok = false

        for (let j = 0; j < length; j++) {
          if (fraiss[j].id && base_self.old_fees[i].id === fraiss[j].id) {
            ok = true
            break
          }
        }

        if (!ok) {
          fraiss_delete.push({
            id: base_self.old_fees[i].id,
            is_active: false
          })
        }
      }

      fraiss.push(...fraiss_delete)

      const fraissNouveau = []
      const fraissAncien = []

      for (let i = 0; i < fraiss.length; i++) {
        if (fraiss[i].id) {
          fraissAncien.push(fraiss[i])
        } else {
          fraissNouveau.push(fraiss[i])
        }
      }

      const dataNouveau = {
        many: true,
        data: fraissNouveau
      }

      const dataAncien = {
        many: true,
        data: fraissAncien
      }

      console.log('dataAncien: ', dataAncien)
      console.log('dataNouveau: ', dataNouveau)

      base_self.$vs.loading()
      if (fraissNouveau.length) {
        base_self.$http
          .post(`${base_self.$store.state.route_for_esm}Frais`, dataNouveau)
          .then((response) => {
            window.getESM.success(
              base_self.$t('The_fees_is_added_successfully'),
              response,
            )
            base_self.$router
              .push('/accounting_management/type_of_fees')
              .catch(() => {})
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
          })
      }

      if (fraissAncien.length) {
        base_self.$http
          .put(`${base_self.$store.state.route_for_esm}Frais`, dataAncien)
          .then((response) => {
            window.getESM.success(
              base_self.$t('The_fees_are_changed_successfully'),
              response,
            )
            base_self.$router
              .push('/accounting_management/type_of_fees')
              .catch(() => {})
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
          })
      }
    },
    /* getAllFrais () {
      base_self.input_classes
    }, */
    async initialiseElement () {
      const dict = {
        custom: {
          anneeDebut: {required: base_self.$t('The_start_year_is_required')},
          anneeFin: {required: base_self.$t('The_end_year_is_required')},
          dateDebut: {required: base_self.$t('The_start_date_is_required')}
        }
      }

      const classesId = []
      let length = base_self.input_classes.length
      for (let i = 0; i < length; i++) {
        classesId.push(base_self.input_classes[i].id)
        
        const item = base_self.input_classes[i]
        base_self.frais_input[item.id] = JSON.parse(JSON.stringify(frais_input_tempon))
        base_self.frais_input[item.id].classe = item.id
        base_self.frais_input[item.id].statutEleves_add = JSON.parse(JSON.stringify(base_self.statutEleves))
        
        dict.custom[`classemontant${item.id}`] = {required: base_self.$t('The_amount_is_required')}
        dict.custom[`classestudentstatus${item.id}`] = {required: base_self.$t('The_amount_is_required')}
        dict.custom[`classenombreDeTranche${item.id}`] = {required: base_self.$t('The_number_of_slice_is_required')}
        for (let j = 1; j < 11; j++) {
          dict.custom[`classemontant${j}-${item.id}`] = {required: base_self.$t('The_amount_is_required')}
          dict.custom[`classedateDebut${j}-${item.id}`] = {required: base_self.$t('The_start_date_is_required')}
          dict.custom[`classedateFin${j}-${item.id}`] = {required: base_self.$t('The_end_date_is_required')}
        }
      }

      if (base_self.is_new) {
        base_self.frais_input_watch(true)
      } else {
        const data = {
          is_get: true,
          paginate: {
            length: 50,
            page: 1
          },
          filter: {
            anneeScolaire__id: base_self.$store.state.anneeScolaire.id,
            typeFrais__id: frais_input_tempon.typeFrais,
            classe__id__in: classesId
          }
        }
        const response = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Frais`, data)
          .catch((error) => {
            console.log('error: ', error)
          })
        
        length = response.data.data.length
        for (let i = 0; i < length; i++) {
          const item = JSON.parse(JSON.stringify(response.data.data[i].classe))

          base_self.frais_input[item.id] = JSON.parse(JSON.stringify(response.data.data[i]))
          const data2 = {
            is_get: true,
            paginate: {
              length: 50,
              page: 1
            },
            filter: {
              fraiss__id: base_self.frais_input[item.id].id
            }
          }
          const response_2 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}StatutEleve`, data2)
            .catch((error) => {
              console.log('error: ', error)
            })

          base_self.frais_input[item.id].statutEleves_add = JSON.parse(JSON.stringify(response_2.data.data))
          base_self.frais_input[item.id].statutEleves_add_old = JSON.parse(JSON.stringify(response_2.data.data))

          const data3 = {
            is_get: true,
            paginate: {
              length: 50,
              page: 1
            },
            filter: {
              frais__id: base_self.frais_input[item.id].id
            },
            orderby: ['ordre']
          }
          const response_3 = await base_self.$http.post(`${base_self.$store.state.route_for_esm}Tranche`, data3)
            .catch((error) => {
              console.log('error: ', error)
            })

          base_self.frais_input[item.id].tranches = JSON.parse(JSON.stringify(response_3.data.data))
          base_self.frais_input[item.id].tranches_old = JSON.parse(JSON.stringify(response_3.data.data))
        }
      }
      
      base_self.frais_input1 = JSON.parse(JSON.stringify(base_self.frais_input))
      base_self.frais_input = JSON.parse(JSON.stringify(base_self.frais_input))
      // base_self.frais_input_watch(true)
      // register custom messages
      Validator.localize('en', dict)
      base_self.formwizard1 = true

      /* function sayHi () {
        base_self.formwizard = true
      }

      setTimeout(sayHi, 2000) */
    },
    async getTypeFraiss () {
      const param = {
        is_get: true,
        filter: {}
      }

      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}TypeFrais`, param)
        .then((response) => {
          base_self.typeFraiss = response.data.data
          base_self.initialiseElement()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    checkFrais () {
      const param = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          typeFrais__id: frais_input_tempon.typeFrais,
          anneeScolaire__id: base_self.$store.state.anneeScolaire.id
        }
      }

      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Frais`, param)
        .then((response) => {
          this.is_new = !(response.data.data.length > 0)
          console.log('new', this.is_new)
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,

    ConfigurationGlobale
  },
  created () {
    base_self = this
    const words = base_self.$route.params.id.split('@')
    frais_input_tempon.typeFrais = Number(words[0])
    frais_input_tempon.nombreDeTranche = Number(words[1])
    base_self.newFeesOrNot()
    base_self.getClasseSpeciale()
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
